import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgPerson = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 20 20'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <mask
      id='person_svg__a'
      width={14}
      height={16}
      x={3}
      y={2}
      maskUnits='userSpaceOnUse'
      style={{
        maskType: 'alpha',
      }}
    >
      <path
        fill={props.color}
        fillRule='evenodd'
        d='M10.252 10.837c2.595.085 4.873 1.474 5.88 3.532.068.141.172.346.23.578.064.262.063.515.02.787-.044.291-.186.574-.31.773s-.316.452-.559.62c-.572.399-1.147.373-1.68.373H6.167c-.533 0-1.108.026-1.68-.373-.243-.168-.435-.42-.559-.619a2.2 2.2 0 0 1-.31-.774 1.95 1.95 0 0 1 .02-.787c.058-.232.162-.437.23-.578 1.04-2.124 3.433-3.536 6.132-3.536zM10 12.5c-2.147 0-3.91 1.121-4.634 2.602a4 4 0 0 0-.085.181 1 1 0 0 0-.025.065l-.002.021a1 1 0 0 0 .009.099l.011.03a1 1 0 0 0 .153.244q.012.014.019.02a.3.3 0 0 0 .141.053c.113.016.264.018.58.018h7.666c.316 0 .467-.002.58-.018a.3.3 0 0 0 .14-.053l.02-.02a1 1 0 0 0 .153-.245q.008-.021.01-.03a1 1 0 0 0 .01-.098l-.003-.021a1 1 0 0 0-.024-.065 4 4 0 0 0-.085-.181C13.91 13.622 12.147 12.5 10 12.5M10 2.083a4.167 4.167 0 1 1 0 8.334 4.167 4.167 0 0 1 0-8.334m0 1.667a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5'
        clipRule='evenodd'
      />
    </mask>
    <g mask='url(#person_svg__a)'>
      <path fill={props.color} d='M0 0h20v20H0z' />
    </g>
  </svg>
)
const ForwardRef = forwardRef(SvgPerson)
export default ForwardRef
